import { SendAnalytics, GenerateLabel } from "../main";

const analytics = SendAnalytics('login and register')
const label = '{users: non user/free/VIP}'

/** 👇 User view register login page */
const ViewLogin = () => analytics({
  label: GenerateLabel({}),
  action: 'login - view login',
  name: 'view_login',
});

/** 👇 User click email login */
const ClickEmailLogin = () => analytics({
  label: GenerateLabel({}),
  action: 'login - click email login',
  name: 'click_email_login',
});

/** 👇 View email login page */
const ViewEmailLoginPage = () => analytics({
  label: GenerateLabel({}),
  action: 'login - view email login page',
  name: 'view_email_login_page',
});

/** 👇 User click login CTA */
const ClickLoginCta = () => analytics({
  label: GenerateLabel({}),
  action: 'login - click login CTA',
  name: 'click_login_cta',
});

/** 👇 User click login google */
const ClickGoogleLogin = () => analytics({
  label: GenerateLabel({}),
  action: 'login - click login google',
  name: 'click_google_login',
});

/** 👇 User click lupa pass */
const ClickLupaPass = () => analytics({
  label: GenerateLabel({}),
  action: 'login - user click lupa pass',
  name: 'click_lupa_pass',
});

/** 👇 User click wa login */
const ClickWaLogin = () => analytics({
  label: GenerateLabel({}),
  action: 'login - click wa login',
  name: 'click_wa_login',
});

/** 👇 User view wa login page */
const ViewWaLoginPage = () => analytics({
  label: GenerateLabel({}),
  action: 'login - view wa login page',
  name: 'view_wa_login_page',
});

/** 👇 User submit WA number */
const SubmitWaNumber = () => analytics({
  label: GenerateLabel({}),
  action: 'login - user submit wa number',
  name: 'submit_wa_number',
});

/** 👇 User view OTP page */
const ViewOtpPage = () => analytics({
  label: GenerateLabel({}),
  action: 'login - view otp page',
  name: 'view_otp_page',
});

/** 👇 user click kirim ulang OTP */
const ClickResendOtp = () => analytics({
  label: GenerateLabel({}),
  action: 'login - click kirim ulang OTP',
  name: 'click_resend_otp',
});

/** 👇 Users succeed Login,
 * loginMethod = email/google/whatsapp/apple
 */
const LoginSuccess = ({ loginMethod = '' }) => analytics({
  label: GenerateLabel({ loginMethod }),
  action: 'login - user succeed login',
  name: 'login_success',
});

/** 👇 User click daftar */
const ClickDaftar = () => analytics({
  label: GenerateLabel({}),
  action: 'login - click daftar',
  name: 'click_daftar',
});

/** 👇 User view register page */
const ViewRegisterPage = () => analytics({
  label: GenerateLabel({}),
  action: 'login - view register page',
  name: 'view_register_page',
});

/** 👇 login - click buat akun */
const ClickCreateAccount = () => analytics({
  label: GenerateLabel({}),
  action: 'login - click buat akun',
  name: 'click_create_account',
});

/** 👇 user click daftar dengan google */
const ClickGoogleRegister = () => analytics({
  label: GenerateLabel({}),
  action: 'login - click daftar dengan google',
  name: 'click_google_register',
});

/** 👇 Users succeed Register,
 * register method = manual/google/apple
 */
const RegisterSuccess = ({ registerMethod = '' }) => analytics({
  label: GenerateLabel({ registerMethod, removeUser: true }),
  action: 'login - user succeed register',
  name: 'register_success',
});

/** 👇 User view tnc */
const ViewTnc = () => analytics({
  label: GenerateLabel({}),
  action: 'login - user view tnc',
  name: 'view_tnc',
});

/** 👇 User setuju tnc */
const ClickSetujuTnc = () => analytics({
  label: GenerateLabel({}),
  action: 'login - user click setuju tnc',
  name: 'click_setuju_tnc',
});

/** 👇 User view disclaimer */
const ViewDisclaimer = () => analytics({
  label: GenerateLabel({}),
  action: 'login - user click setuju tnc',
  name: 'view_disclaimer',
});

/** 👇 User setuju disclaimer */
const ClickSetujuDisclaimer = () => analytics({
  label: GenerateLabel({}),
  action: 'login - user click setuju disclaimer',
  name: 'click_setujuDisclaimer',
});

const LoginRegister = {
  ViewLogin,
  ClickEmailLogin,
  ViewEmailLoginPage,
  ClickLoginCta,
  ClickGoogleLogin,
  ClickLupaPass,
  ClickWaLogin,
  ViewWaLoginPage,
  SubmitWaNumber,
  ViewOtpPage,
  ClickResendOtp,
  LoginSuccess,
  ClickDaftar,
  ViewRegisterPage,
  ClickCreateAccount,
  ClickGoogleRegister,
  RegisterSuccess,
  ViewTnc,
  ClickSetujuTnc,
  ViewDisclaimer,
  ClickSetujuDisclaimer,
};

export default LoginRegister;
